import React, { createContext, useState, useEffect } from "react";

export const UserContext = createContext();
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = sessionStorage.getItem("userinfo");
      if (storedUser) {
        const parsed = JSON.parse(storedUser);
        if (parsed?.userId) {
          setUser(parsed);
        } else {
          sessionStorage.removeItem("userinfo");
        }
      }
    } catch (error) {
      console.error("Failed to load stored user:", error);
      sessionStorage.removeItem("userinfo");
    } finally {
      setLoading(false);
    }
  }, []);
  const login = (userData) => {
    setUser(userData);
    sessionStorage.setItem("userinfo", JSON.stringify(userData)); // ✅
  };
  const logout = () => {
    setUser(null);
    sessionStorage.removeItem("userinfo"); // ✅
  };
  return (
    <UserContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </UserContext.Provider>
  );
};
